import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { Router } from '@angular/router';
import { CurrentUserService } from '../../services/current-user.service';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-terms-modal',
    templateUrl: './terms-modal.component.html',
    standalone: false
})
export class TermsModalComponent {
  faSpinnerThird = faSpinnerThird;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private currentUserService: CurrentUserService,
    private modalService: NgbModal,
  ) { }

  async cancel() {
    const confirmModal = this.modalService.open(ConfirmModalComponent, {
      centered: true,
      scrollable: true,
      backdrop: 'static',
      keyboard: false
    });

    confirmModal.componentInstance.title = 'Signing Out';
    confirmModal.componentInstance.content = `As you don't accept our Terms and Conditions, you will be signed you out of TRACit.<br><br>You can contact us via <a href="mailto:support@tracit.com.au">support@tracit.com.au</a> or <a href="tel:1300872248">1300 872 248</a> if you wish to cancel your subscription.`;
    confirmModal.componentInstance.contentIsHtml = true;
    confirmModal.componentInstance.falseLabel = 'Cancel';
    confirmModal.componentInstance.trueLabel = 'Sign Out';
    confirmModal.componentInstance.switchButtonColour = 'Sign Out';

    const result = await confirmModal.result;

    if (result) {
      this.router.navigate(['/signout']);
    }
  }

  accept() {
    this.currentUserService.acceptTerms$();
  }
}
